import { useState } from "react";
import { Button } from "@/components/ui/Button";

const MAX_CHIPS = 6;

const RequirementChips = ({ items, tone, icon: Icon, label }) => {
  const [expanded, setExpanded] = useState(false);
  if (!items?.length) return null;

  const shown = expanded ? items : items.slice(0, MAX_CHIPS);
  const hidden = items.length - shown.length;

  return (
    <div className="flex items-start gap-2">
      <span className={`mt-0.5 flex shrink-0 items-center gap-1 ${tone.text}`} title={label}>
        <Icon size={14} strokeWidth={2.5} aria-hidden="true" />
        <span className="sr-only">{label}</span>
      </span>
      <div className="flex flex-wrap gap-1">
        {shown.map((item) => (
          <span key={item} className={`inline-flex max-w-full items-center truncate rounded-md border px-1.5 py-0.5 text-xs text-text-primary ${tone.bg} ${tone.border}`}>
            {item}
          </span>
        ))}
        {hidden > 0 && (
          <Button
            onClick={() => setExpanded(true)}
            className="rounded-md border border-border-primary px-1.5 py-0.5 text-xs text-text-secondary transition-colors hover:text-text-primary"
          >
            +{hidden} more
          </Button>
        )}
        {expanded && items.length > MAX_CHIPS && (
          <Button
            onClick={() => setExpanded(false)}
            className="rounded-md border border-border-primary px-1.5 py-0.5 text-xs text-text-secondary transition-colors hover:text-text-primary"
          >
            Show less
          </Button>
        )}
      </div>
    </div>
  );
};

export default RequirementChips;
